(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4732],{

/***/ 8526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightGrey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".ArrowRightGrey_svg__arrow_right_b{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "ArrowRightGrey_svg__arrow_right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightGrey);

/***/ }),

/***/ 83241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSearchWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.304 19.88a9.845 9.845 0 01-5.28 1.53C5.487 21.41 1 16.841 1 11.205S5.488 1 11.023 1c5.536 0 10.023 4.569 10.023 10.205 0 2.793-1.102 5.325-2.888 7.167l4.497 4.579c.46.468.46 1.229 0 1.697a1.164 1.164 0 01-1.668 0l-4.683-4.768zm2.384-8.675c0 4.31-3.432 7.804-7.665 7.804-4.233 0-7.665-3.494-7.665-7.804 0-4.31 3.432-7.804 7.665-7.804 4.233 0 7.665 3.494 7.665 7.804z",
    fill: "#fff",
    stroke: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgSearchWhite);

/***/ }),

/***/ 48503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgDownArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.884 8.116a1.25 1.25 0 010 1.768l-7 7a1.25 1.25 0 01-1.768 0l-7-7a1.25 1.25 0 111.768-1.768L12 14.232l6.116-6.116a1.25 1.25 0 011.768 0z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgDownArrow);

/***/ }),

/***/ 99372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ d; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
var c=function(){return c=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},c.apply(this,arguments)};var s=function(e){return"object"==typeof e},f=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];return e.filter((function(e){return!s(e)&&!1!==e})).join(" ")},p=function(r){var o=r.placeholder,l=r.separator,p=r.isLastChild,d=r.inputStyle,y=r.focus,v=r.isDisabled,h=r.hasErrored,g=r.errorStyle,m=r.focusStyle,b=r.disabledStyle,S=r.shouldAutoFocus,D=r.isInputNum,k=r.index,I=r.value,O=r.className,x=r.isInputSecure,C=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}(r,["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"]),N=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=N.current;e&&y&&S&&e.focus()}),[]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=N.current;y&&e&&(e.focus(),e.select())}),[y]);var j=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return x?"password":D?"tel":"text"}),[x,D]);return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div",c({className:O,style:{display:"flex",alignItems:"center"}},{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input",c({"aria-label":"".concat(0===k?"Please enter verification code. ":"").concat(D?"Digit":"Character"," ").concat(k+1),autoComplete:"off",style:Object.assign({width:"1em",textAlign:"center"},s(d)&&d,y&&s(m)&&m,v&&s(b)&&b,h&&s(g)&&g),placeholder:o,className:f(d,y&&m,v&&b,h&&g),type:j,ref:N,disabled:v,value:I||""},C)),!p&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment,{children:l})]}))},d=(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((function(t,n){var r=t.numInputs,i=void 0===r?4:r,u=t.onChange,f=void 0===u?function(e){return console.log(e)}:u,d=t.isDisabled,y=void 0!==d&&d,v=t.shouldAutoFocus,h=void 0!==v&&v,g=t.value,m=void 0===g?"":g,b=t.isInputSecure,S=void 0!==b&&b,D=t.placeholder,k=t.isInputNum,I=t.containerStyle,O=t.inputStyle,x=t.focusStyle,C=t.separator,N=t.disabledStyle,j=t.hasErrored,w=t.errorStyle,A=t.className,E=t["data-cy"],P=t["data-testid"],F=(0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),L=F[0],B=F[1],M=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return m?m.toString().split(""):[]}),[m]),q=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){if("string"==typeof D){if(D.length===i)return D;if(D.length>0)return console.error("Length of the placeholder should be equal to the number of inputs."),""}return""}),[i,D]);(0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(n,(function(){return{focusInput:T}}));var K=function(e){var t=e.join("");f(t)},R=function(e){return(k?!isNaN(parseInt(e,10)):"string"==typeof e)&&1===e.trim().length},T=function(e){var t=Math.max(Math.min(i-1,e),0);B(t)},z=function(){T(L+1)},G=function(){T(L-1)},H=function(e){M[L]=e[0],K(M)},J=function(e){if(e.preventDefault(),!y){for(var t=L,n=e.clipboardData.getData("text/plain").slice(0,i-L).split(""),r=0;r<i;++r)r>=L&&n.length>0&&(M[r]=n.shift(),t++);B(t),T(t),K(M)}},Q=function(e){8===e.keyCode||"Backspace"===e.key?(e.preventDefault(),H(""),G()):46===e.keyCode||"Delete"===e.key?(e.preventDefault(),H("")):37===e.keyCode||"ArrowLeft"===e.key?(e.preventDefault(),G()):39===e.keyCode||"ArrowRight"===e.key?(e.preventDefault(),z()):32!==e.keyCode&&" "!==e.key&&"Spacebar"!==e.key&&"Space"!==e.key||e.preventDefault()},U=function(e){if(R(e.target.value))z();else if(!k){var t=e.nativeEvent;null===t.data&&"deleteContentBackward"===t.inputType&&(e.preventDefault(),H(""),G())}},V=function(e){return function(t){B(e),t.target.select()}},W=function(){return B(-1)};return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div",c({style:Object.assign({display:"flex"},s(I)&&I),className:s(I)?"":I},{children:new Array(i).fill(null).map((function(t,n){var r,o;return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(p,{placeholder:null!==(r=q[n])&&void 0!==r?r:"",index:n,focus:L===n,value:M[n],onChange:(o=n,function(e){var t=e.target.value;0!==o||t.length!==i?R(t)&&H(t):K(t.split(""))}),onKeyDown:Q,onInput:U,onPaste:J,onFocus:V(n),onBlur:W,separator:C,inputStyle:O,focusStyle:x,isLastChild:n===i-1,isDisabled:y,disabledStyle:N,hasErrored:j,errorStyle:w,shouldAutoFocus:h,isInputNum:k,isInputSecure:S,className:A,"data-cy":E&&"".concat(E,"-").concat(n),"data-testid":P&&"".concat(P,"-").concat(n)},n)}))}))}));
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 58810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _quick_action_popup_QuickActionPopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37372);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_dist_icons_searchWhite_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83241);
/* harmony import */ var _vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60054);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26513);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17073);









var LoadNotAvailablePopup = function(props) {
    var isMobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var isOpen = props.isOpen, onSubmit = props.onSubmit, onToggle = props.onToggle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_quick_action_popup_QuickActionPopup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onToggle: onToggle,
        titleText: "Load no longer available",
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* .VerticalFlex */ .vs, {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* .VerticalFlex */ .vs, {
                gap: 8,
                style: isMobileScreen ? undefined : {
                    maxWidth: 400
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_8__["default"], {
                            src: "out-of-stock.png",
                            width: 120,
                            height: 120
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        weight: "semibold",
                        size: "md",
                        align: "center",
                        children: "Looks like this load has been booked!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        weight: "medium",
                        align: "center",
                        children: "Don't worry! You can still find similar loads from the same location"
                    })
                ]
            })
        }),
        ctaAction: onSubmit,
        ctaText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            gap: 8,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_searchWhite_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                "Find similar loads"
            ]
        }),
        ctaProps: {
            isRounded: true,
            blockBtn: true
        },
        modalSize: "compact"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadNotAvailablePopup);


/***/ }),

/***/ 4564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MarketplacePostingNudgeCards, MarketplaceListItemWithNudges */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32450);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94204);
/* harmony import */ var _hooks_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4641);
/* harmony import */ var _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8574);
/* harmony import */ var _hooks_useOpenNewLoadPosting__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68498);
/* harmony import */ var _posting_helpers_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40607);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17073);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10182);
/* harmony import */ var _marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98712);
/* harmony import */ var _MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49256);
/* harmony import */ var _MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15__);


















var MarketplacePostingNudgeCard = function(param) {
    var type = param.type;
    var ValidateLorryPosting = (0,_hooks_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().ValidateLorryPosting;
    var loadLorryPostingConfig = (0,_context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .useLoadLorryPosting */ .NS)();
    var openNewLoadPosting = (0,_hooks_useOpenNewLoadPosting__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_13__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    var content = _marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_14__/* .MARKETPLACE_POSTING_NUDGE_CONTENT */ .X9[type];
    var handleClick = function() {
        if (type === "load") {
            sendGAandMoEngageEvent({
                name: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__/* .GA4EventNames.MARKET_PLACE.post_load_button_click */ .wQR.MARKET_PLACE.post_load_button_click,
                data: {
                    source_screen: "marketplace"
                }
            });
            openNewLoadPosting({
                originationPage: _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */ .ec.MARKETPLACE
            });
            return;
        }
        ValidateLorryPosting(function() {
            setTimeout(function() {
                sendGAandMoEngageEvent({
                    name: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__/* .GA4EventNames.MARKET_PLACE.add_lorry_attach_lorry_btn */ .wQR.MARKET_PLACE.add_lorry_attach_lorry_btn,
                    data: {
                        source_screen: "marketplace"
                    }
                });
                loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.updateLoadLorryPostingData({
                    isModalOpen: true,
                    category: "post",
                    originationPage: _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */ .ec.MARKETPLACE,
                    type: "lorry"
                });
                loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.openLorryPostingModal(_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_11__/* .LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */ .jU.VEHICLE_NUMBER);
            }, 1000);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default().main), (_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default())[type]),
        gap: 20,
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_12__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, content.image), {
                unoptimized: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                flexDirection: "column",
                gap: 20,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default().textWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].WHITE */ .Z.WHITE,
                            weight: "medium",
                            align: "center",
                            mSize: "sm",
                            children: content.label
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        isRounded: true,
                        type: "button",
                        color: "tertiary",
                        blockBtn: true,
                        onClick: handleClick,
                        children: content.cta
                    })
                ]
            })
        ]
    });
};
var MarketplacePostingNudgeCards = function(param) {
    var types = param.types;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: types.map(function(type) {
            return /*#__PURE__*/ _jsx(MarketplacePostingNudgeCard, {
                type: type
            }, type);
        })
    });
};
var MarketplaceListItemWithNudges = function(param) {
    var nudgeTypes = param.nudgeTypes, showBefore = param.showBefore, showAfter = param.showAfter, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showBefore ? /*#__PURE__*/ _jsx(MarketplacePostingNudgeCards, {
                types: nudgeTypes
            }) : null,
            children,
            showAfter ? /*#__PURE__*/ _jsx(MarketplacePostingNudgeCards, {
                types: nudgeTypes
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MarketplacePostingNudgeCard);


/***/ }),

/***/ 98712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ LOAD_MARKETPLACE_POSTING_NUDGE_TYPES; },
/* harmony export */   "Tm": function() { return /* binding */ MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX; },
/* harmony export */   "X9": function() { return /* binding */ MARKETPLACE_POSTING_NUDGE_CONTENT; }
/* harmony export */ });
/* unused harmony exports LORRY_MARKETPLACE_POSTING_NUDGE_TYPES, MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX, getMarketplacePostingNudgeIndex, getMarketplaceNudgePlacement */
/** Nudge cards shown on load marketplace (truckers + shippers). */ var LOAD_MARKETPLACE_POSTING_NUDGE_TYPES = [
    "lorry",
    "load"
];
/** Nudge card shown on lorry marketplace (shippers). */ var LORRY_MARKETPLACE_POSTING_NUDGE_TYPES = (/* unused pure expression or super */ null && ([
    "load"
]));
var MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX = 5;
var MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX = 1;
var MARKETPLACE_POSTING_NUDGE_CONTENT = {
    load: {
        image: {
            src: "/load-icons/v1/Load.png",
            width: 70,
            height: 77
        },
        label: "Post your load to get matching lorries",
        cta: "Post Load"
    },
    lorry: {
        image: {
            src: "/lorry-icons/v3/Container.png",
            width: 156,
            height: 74
        },
        label: "Add your lorry to get matching loads",
        cta: "Post Lorry"
    }
};
function getMarketplacePostingNudgeIndex(isMobileScreen) {
    return isMobileScreen ? MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX : MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX;
}
function getMarketplaceNudgePlacement(cardCount, index, nudgeIndex) {
    var isNudgePositionLast = cardCount > 0 && cardCount <= nudgeIndex && cardCount === index + 1;
    var isNudgeSlot = index === nudgeIndex || isNudgePositionLast;
    return {
        isNudgeSlot: isNudgeSlot,
        showBefore: isNudgeSlot && !isNudgePositionLast,
        showAfter: isNudgeSlot && isNudgePositionLast
    };
}


/***/ }),

/***/ 94280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XT": function() { return /* binding */ getMarketplaceLoadFaqList; },
/* harmony export */   "Xq": function() { return /* binding */ getMarketplaceInCityTextForSeoContent; },
/* harmony export */   "l$": function() { return /* binding */ getLorryTypeFromParam; },
/* harmony export */   "nH": function() { return /* binding */ parseMarketplaceLocationFromParamSegment; },
/* harmony export */   "sP": function() { return /* binding */ resolveMarketplaceLoadSeoContext; }
/* harmony export */ });
/* unused harmony exports botTest, formatMarketplaceLocationSlug, formatMarketplaceLocationLabel, getMarketplaceInCityTextFromSegment, getMarketplaceLegacyCityMeta */
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);
/* harmony import */ var _marketplace_content_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79733);


function getLorryTypeFromParam(lorryParam) {
    var req = Array.isArray(lorryParam) ? lorryParam : [
        lorryParam
    ];
    return (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAllowedVehicleList */ .UE5)("lorry").filter(function(lorryType) {
        return req === null || req === void 0 ? void 0 : req.includes(lorryType.label.toLowerCase());
    });
}
function botTest(userAgent) {
    return /bot|crawler|spider|googlebot|bingbot|msnbot|yandexbot|baiduspider|slurp|duckduckbot/i.test(userAgent);
}
/** Mirrors SSR parsing in `pages/marketplace/[...params].tsx`. */ function parseMarketplaceLocationFromParamSegment(segment) {
    var ref, ref1;
    if (!segment) {
        return {
            src: "",
            dest: ""
        };
    }
    var locationParts = segment.split("to-");
    var ref2, ref3;
    return {
        src: (ref2 = (ref = locationParts[0]) === null || ref === void 0 ? void 0 : ref.replace(/-/g, " ")) !== null && ref2 !== void 0 ? ref2 : "",
        dest: locationParts.length === 2 ? (ref3 = (ref1 = locationParts[1]) === null || ref1 === void 0 ? void 0 : ref1.replace(/-/g, " ")) !== null && ref3 !== void 0 ? ref3 : "" : ""
    };
}
/** Format a marketplace URL slug (e.g. bengaluru-karnataka-india) for display in meta copy. */ function formatMarketplaceLocationSlug(slug) {
    return slug.replace(/-india$/i, "").replace(/-/g, " ").replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });
}
/** Format SSR-parsed location text (e.g. "bengaluru karnataka india") for display. */ function formatMarketplaceLocationLabel(label) {
    return label.replace(/\s+india\s*$/i, "").replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    }).trim();
}
/** Legacy-compatible "in Bengaluru Karnataka" text for on-page SEO content lookup. */ function getMarketplaceInCityTextFromSegment(locationSegment) {
    if (!locationSegment) {
        return "";
    }
    var cityDisplayName = formatMarketplaceLocationSlug(locationSegment);
    return cityDisplayName ? "in ".concat(cityDisplayName) : "";
}
/** Shared in-city phrase for FAQ blocks, H1 copy, and legacy marketplace pages. */ function getMarketplaceInCityTextForSeoContent(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest;
    var seoContext = resolveMarketplaceLoadSeoContext({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    if (seoContext.kind === "city" || seoContext.kind === "destination") {
        return seoContext.inCityText;
    }
    if (locationSegment) {
        return getMarketplaceInCityTextFromSegment(locationSegment);
    }
    return "";
}
function resolveMarketplaceLoadSeoContext(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest;
    var parsed = parseMarketplaceLocationFromParamSegment(locationSegment);
    var src = (urlSrc || parsed.src).trim();
    var dest = (urlDest || parsed.dest).trim();
    if (src && dest) {
        var fromCity = formatMarketplaceLocationLabel(src);
        var toCity = formatMarketplaceLocationLabel(dest);
        return {
            kind: "route",
            fromCity: fromCity,
            toCity: toCity,
            routeLabel: "".concat(fromCity, " to ").concat(toCity)
        };
    }
    if (dest) {
        var cityDisplayName = formatMarketplaceLocationLabel(dest);
        return {
            kind: "destination",
            cityDisplayName: cityDisplayName,
            inCityText: "in ".concat(cityDisplayName)
        };
    }
    if (src) {
        var cityDisplayName1 = formatMarketplaceLocationLabel(src);
        return {
            kind: "city",
            cityDisplayName: cityDisplayName1,
            inCityText: "in ".concat(cityDisplayName1)
        };
    }
    if (locationSegment === null || locationSegment === void 0 ? void 0 : locationSegment.startsWith("to-")) {
        var cityDisplayName2 = formatMarketplaceLocationSlug(locationSegment.replace(/^to-/, ""));
        return {
            kind: "destination",
            cityDisplayName: cityDisplayName2,
            inCityText: "in ".concat(cityDisplayName2)
        };
    }
    if (locationSegment) {
        var cityDisplayName3 = formatMarketplaceLocationSlug(locationSegment);
        return {
            kind: "city",
            cityDisplayName: cityDisplayName3,
            inCityText: "in ".concat(cityDisplayName3)
        };
    }
    return {
        kind: "default"
    };
}
/** City-aware FAQ for marketplace load pages — falls back to generic list when no location in URL. */ function getMarketplaceLoadFaqList(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest, genericFaqList = param.genericFaqList;
    var inCityText = getMarketplaceInCityTextForSeoContent({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    if (inCityText) {
        return (0,_marketplace_content_content__WEBPACK_IMPORTED_MODULE_1__/* .getMktContentByCity */ .o)(inCityText, true).faqList;
    }
    return genericFaqList;
}
/** English meta copy for legacy marketplace v2 (load + lorry routes). */ function getMarketplaceLegacyCityMeta(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest, isLoadMarket = param.isLoadMarket, _fallbackCityText = param.fallbackCityText, fallbackCityText = _fallbackCityText === void 0 ? "" : _fallbackCityText;
    var seoContext = resolveMarketplaceLoadSeoContext({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    var cityDisplayName = fallbackCityText;
    if (seoContext.kind === "city" || seoContext.kind === "destination") {
        cityDisplayName = seoContext.cityDisplayName;
    } else if (seoContext.kind === "route") {
        cityDisplayName = seoContext.routeLabel;
    } else if (locationSegment) {
        cityDisplayName = formatMarketplaceLocationSlug(locationSegment);
    }
    var cityTextWithoutIndia = cityDisplayName;
    var inCityTextWithoutIndia = cityDisplayName ? "in ".concat(cityDisplayName) : "";
    var inCityText = inCityTextWithoutIndia;
    var metaTitle = isLoadMarket ? cityDisplayName ? "Find Truck Load Online in ".concat(cityDisplayName, " - India's Top Transport Marketplace") : "Find Instant Truck Load Online - India's Top Transport Marketplace" : cityDisplayName ? "Find Online Truck Booking in ".concat(cityDisplayName, " - India's Top Marketplace") : "Book Your Truck Online : India's Top Lorry Booking Marketplace";
    var metaDescription = isLoadMarket ? "Book truck loads online in ".concat(cityDisplayName, " with ease. Our online platform offers GST and Aadhaar Verified Transport Services, truck owners and agents at your convenience. Book now.") : "Find instant truck, load, and lorry bookings online in ".concat(cityDisplayName, " on India's largest transport marketplace. Streamline your logistics with ease. Register & Bid Now!");
    var metaKeywords = isLoadMarket ? "truck load booking near me, online load booking ".concat(inCityText, ", load booking ").concat(cityDisplayName, ", find truck loads ").concat(inCityText, ", find load for my truck ").concat(inCityText, ", how to find load for truck, truck attachment ").concat(inCityText) : "truck booking ".concat(cityDisplayName, ", online truck booking ").concat(inCityText, ", truck booking app ").concat(cityDisplayName, ", mini truck transport ").concat(inCityText, ", online mini truck booking ").concat(cityDisplayName);
    return {
        city: cityDisplayName,
        CITY_TEXT_WITHOUT_INDIA: cityTextWithoutIndia,
        IN_CITY_TEXT: inCityText,
        IN_CITY_TEXT_WITHOUT_INDIA: inCityTextWithoutIndia,
        META_TITLE: metaTitle,
        META_DESCRIPTION: metaDescription,
        META_KEYWORDS: metaKeywords
    };
}


/***/ }),

/***/ 79733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getMktContentByCity; }
/* harmony export */ });
var getMktContentByCity = function(IN_CITY_TEXT, isLoad) {
    var loadLorryText = isLoad ? "load" : "lorry";
    var titleH1Desc = "Vahak is India’s largest and most trusted online transport services company ".concat(IN_CITY_TEXT, ". We at Vahak are committed to improving the Indian transportation services industry through a technology-driven approach. Through our platform, we are helping reduce the current demand-supply gap in the transport industry by providing instant online ").concat(loadLorryText, " ").concat(IN_CITY_TEXT, ".\n    Vahak hosts India’s largest ").concat(loadLorryText, " marketplace, allowing users to book transport services instantly without paying commission charges. Through the Vahak Transport Marketplace, users can bid & book loads or lorries from across India.");
    var content = [
        {
            title: "Why Choose Vahak Marketplace Portal ".concat(IN_CITY_TEXT),
            description: [
                {
                    id: 0,
                    content: "With Vahak, explore the best platform for loads and vehicles ".concat(IN_CITY_TEXT, ". Embark on a revolutionary transportation experience with Vahak in now, a marketplace tailored to fulfil all of your logistical requirements.")
                }
            ],
            contentList: [
                {
                    id: 0,
                    title: "Registered Transporters",
                    description: "With Vahak, you can feel secure knowing that each transporter has their Aadhar and GST validated. Your safety and security are our top priorities, and Vahak ensures you work with reliable and respectable experts."
                },
                {
                    id: 1,
                    title: "Shippers' Profiles",
                    description: "Get access to extensive shipper profiles, enabling you to make knowledgeable selections. Such profiles offer crucial information that will assist you in selecting the ideal partners for your logistical needs."
                },
                {
                    id: 2,
                    title: "Reliable Transportation",
                    description: "Make use of Vahak's trustworthy and efficient transport services to maximise your logistics. Your items will be transported quickly and safely to their destination thanks to the efficiency of the platform."
                },
                {
                    id: 3,
                    title: "Extensive Network",
                    description: "Take advantage of our vast network of shippers and carriers throughout. Vahak gives you access to a large community, thereby improving the likelihood of discovering the ideal travel options."
                },
                {
                    id: 4,
                    title: "Cost-effective Pricing",
                    description: "Take advantage of the affordable pricing strategy, which is intended to give you the most value for your money. Vahak enables you to control your transportation expenses efficiently and transparently."
                }
            ]
        }
    ];
    var faqList = [
        {
            question: "How do I use the Vahak Marketplace to find ".concat(loadLorryText, " ").concat(IN_CITY_TEXT, "?"),
            answer: "While searching over the Vahak portal, opt for the find ".concat(loadLorryText, " option ").concat(IN_CITY_TEXT, ". Find ").concat(loadLorryText, " as per your choice.")
        },
        {
            question: "How can I filter ".concat(loadLorryText, " listings based on my preferences?"),
            answer: "Utilise Vahak's comprehensive search parameters to refine your ".concat(loadLorryText, " of listings. To swiftly identify the best choices, you may select by cargo type, weight, destination, and other factors.")
        },
        {
            question: "How do I submit a bid for a load on the Vahak Marketplace?",
            answer: 'Select the load you’re interested in, click on "Submit Bid," and enter your bid amount along with any relevant details. Confirm your bid to send it to the load provider.'
        },
        {
            question: "Can I track the status of my bid submissions?",
            answer: "To monitor the status of my bid submissions, you can simply search for the 'My Bids' section. Here, you will know if your bid was approved or likely to be approved."
        },
        {
            question: "Is there a messaging system available to communicate with load providers?",
            answer: "Vahak offers a built-in messaging system that allows you to communicate directly with load providers."
        },
        {
            question: "What payment methods are accepted for load transactions?",
            answer: "Vahak supports transactions through digital wallets, debit cards, UPI, and bank transfers."
        }
    ];
    return {
        titleH1Desc: titleH1Desc,
        content: content,
        faqList: faqList
    };
};


/***/ }),

/***/ 68802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useGetLoadMarketInfiniteQueryNew; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46492);








var useGetLoadMarketInfiniteQueryNew = function(params, options) {
    var method = function method(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var finalPreload = isAdmin ? preloads : preloads === null || preloads === void 0 ? void 0 : preloads.filter(function(val) {
            return val != "agent_details";
        });
        var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, restParams), {
            page: pageParam,
            l: l,
            id: loadId,
            preloads: finalPreload
        });
        var urlString = (0,_vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T9)(payload);
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__/* ["default"].LOAD_MARKET_V2_NEW */ .Z.LOAD_MARKET_V2_NEW).concat(urlString));
    };
    var page = params.page, l = params.l, preloads = params.preloads, isAdmin = params.isAdmin, loadId = params.loadId, restParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(params, [
        "page",
        "l",
        "preloads",
        "isAdmin",
        "loadId"
    ]);
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().GET;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakInfiniteQuery */ .xX)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadMarketInfiniteQueryV2 */ .Z.getLoadMarketInfiniteQueryV2,
        params
    ], method, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        getNextPageParam: function(lastPage, allPages) {
            var ref, ref1, ref2;
            if (((ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.page_number) < ((ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.total_pages)) return ((ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.page_number) + 1;
            return undefined;
        }
    }, options), {
        onSuccess: function(data) {
            var ref, ref1;
            var ref2;
            var aggregatedData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                total_pages: 0,
                total_records: 0,
                page_number: 0
            }, data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref[0]), {
                load_cards: data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap(function(page) {
                    var ref;
                    return (ref2 = page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.load_cards) !== null && ref2 !== void 0 ? ref2 : [];
                })
            });
            /**
             * Enclosing aggregatedData inside an array, just to fix the type script
             * as the onSuccess returns only aggregatedData[] - array type
             */ options.onSuccess([
                aggregatedData
            ]);
        },
        refetchOnWindowFocus: false
    }));
};


/***/ }),

/***/ 32689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useGetLoadMarketV2New; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73435);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46492);









/**
 * Need to get rid of LoadMarketDetails (type)
 */ /**
 * Load market v2 api
 * @param param0
 * @param options
 * @returns
 */ var useGetLoadMarketV2New = function(_param, options) {
    var page = _param.page, c_i = _param.c_i, lorry_type_id = _param.lorry_type_id, city_id = _param.city_id, state_id = _param.state_id, destination_city_id = _param.destination_city_id, destination_state_id = _param.destination_state_id, quantity_string = _param.quantity_string, l = _param.l, preloads = _param.preloads, isAdmin = _param.isAdmin, loadId = _param.loadId, destination_place_id = _param.destination_place_id, source_place_id = _param.source_place_id, tap_n_go_filter = _param.tap_n_go_filter, restParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "page",
        "c_i",
        "lorry_type_id",
        "city_id",
        "state_id",
        "destination_city_id",
        "destination_state_id",
        "quantity_string",
        "l",
        "preloads",
        "isAdmin",
        "loadId",
        "destination_place_id",
        "source_place_id",
        "tap_n_go_filter"
    ]);
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().GET;
    var payload = {
        page: page,
        c_i: c_i,
        lorry_type_id: lorry_type_id,
        city_id: city_id,
        state_id: state_id,
        destination_city_id: destination_city_id,
        destination_state_id: destination_state_id,
        quantity_string: quantity_string,
        destination_place_id: destination_place_id,
        source_place_id: source_place_id,
        l: l,
        tap_n_go_filter: tap_n_go_filter,
        status_id: restParams === null || restParams === void 0 ? void 0 : restParams.status,
        expiry_timestamp: restParams === null || restParams === void 0 ? void 0 : restParams.expiry_timestamp
    };
    var urlString = (0,_vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T9)(payload);
    var idString = loadId && (0,_vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_6__/* .generateUrlParamsFromArray */ .L)(loadId, "id");
    var preloadsString = preloads && (0,_vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_6__/* .generateUrlParamsFromArray */ .L)(preloads, "preloads", !isAdmin ? [
        "agent_details"
    ] : undefined);
    var getLoadMarketV2Data = function() {
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__/* ["default"].LOAD_MARKET_V2_NEW */ .Z.LOAD_MARKET_V2_NEW).concat(urlString).concat(idString ? "&" + idString : "").concat(preloadsString ? "&" + preloadsString : ""));
    };
    /**
     * If you don't know the error type pass unknown
     */ return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakQuery */ .uE)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadMarketV2 */ .Z.getLoadMarketV2
    ], getLoadMarketV2Data, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            return data.data;
        }
    }));
};


/***/ }),

/***/ 16038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ usePlaceSearchQuery; },
/* harmony export */   "u": function() { return /* binding */ usePlaceSearchMutation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_methods_generateQueryString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99073);
/* harmony import */ var _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20803);
/* harmony import */ var _vahak_core_dist_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63478);









var usePlaceSearchQuery = function(param, options) {
    var _query = param.query, option = param.option, _debounceDelay = param.debounceDelay, debounceDelay = _debounceDelay === void 0 ? 1000 : _debounceDelay;
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().GET;
    var debouncedQuery = (0,_vahak_core_dist_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_5__/* .useDebounce */ .N)(_query, debounceDelay);
    var method = function() {
        var ref = option !== null && option !== void 0 ? option : {}, source = ref.source, is_state_allowed = ref.allowState, tag = ref.tag, searchSessionToken = ref.searchSessionToken;
        var payload = {
            tag: tag,
            source: source,
            is_state_allowed: is_state_allowed,
            session_token: searchSessionToken
        };
        var urlString = (0,_vahak_core_dist_methods_generateQueryString__WEBPACK_IMPORTED_MODULE_6__/* .generateQueryString */ .T)(payload);
        if (!debouncedQuery || debouncedQuery.length < _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z) {
            return {
                data: []
            };
        }
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PLACES_API_SEARCH */ .Z.PLACES_API_SEARCH).concat(debouncedQuery, "&").concat(urlString), {});
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakQuery */ .uE)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.searchLocation */ ._.searchLocation,
        option,
        debouncedQuery
    ], method, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            var ref;
            return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : [];
        }
    }));
};
var usePlaceSearchMutation = function() {
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().GET;
    var method = function(params) {
        var query = params.query, option = params.option;
        var ref = option !== null && option !== void 0 ? option : {}, source = ref.source, is_state_allowed = ref.allowState, tag = ref.tag;
        var payload = {
            tag: tag,
            source: source,
            is_state_allowed: is_state_allowed,
            session_token: option === null || option === void 0 ? void 0 : option.searchSessionToken
        };
        var urlString = (0,_vahak_core_dist_methods_generateQueryString__WEBPACK_IMPORTED_MODULE_6__/* .generateQueryString */ .T)(payload);
        if (!query || query.length < _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z) {
            return new Promise(function(resolve) {
                return resolve({
                    data: []
                });
            });
        }
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PLACES_API_SEARCH */ .Z.PLACES_API_SEARCH).concat(query, "&").concat(urlString));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakMutationQuery */ .M8)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.searchLocation */ ._.searchLocation
    ], method);
};


/***/ }),

/***/ 49256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"MarketplacePostingNudgeCard_main__4tvA0","textWrapper":"MarketplacePostingNudgeCard_textWrapper__TXajM"};

/***/ })

}]);